import React from "react";
import { Icon, PlainButton, SelectField, Tooltip } from "@culturehq/components";

import { useFetch, useStoryQuestions } from "app/hooks";
import { getQuestionsOptions, t } from "app/utils";
import StoryQuestion from "components/stories/StoryQuestion";
import { usePostStoryContext } from "../../contexts/PostStoryContext";
import { DefaultStory } from "../../types";

const defaultStory: DefaultStory = {
  question: null,
  body: null
};

const PromptSelector = () => {
  const { getStoryQuestions } = useStoryQuestions();
  const {
    state: { currentStory, selectedPrompt, selectedQuestion },
    story: storyProp,
    handleEditQuestion,
    handleSelectQuestion
  } = usePostStoryContext();

  const editPrompt = !!storyProp;
  const newPrompt = !!selectedQuestion;
  const story = currentStory || defaultStory;

  const {
    fetching,
    json: { storyQuestions = [] }
  } = useFetch(
    () => getStoryQuestions({
      answerable: story.question ? undefined : true,
      all: !!story.question
    }),
    [story.question]
  );

  const handleOnSelectQuestion = (selectedQuestion: any) => {
    handleSelectQuestion(selectedQuestion);
  };

  return (
    <>
      {selectedPrompt && !newPrompt ? (
        <>
          <div className="gallery-lightbox__title-container">
            <h1 id="post-story-title" className="title">
              {selectedPrompt.question}
            </h1>
            {editPrompt && (
              <PlainButton>
                <Icon icon="edit" onClick={handleEditQuestion} />
              </PlainButton>
            )}
          </div>
          <Tooltip
            tip={t(
              "This is a default prompt and can't be edited. To create your own, click the add your own story button in the feed."
            )}
          >
            <SelectField
              className="Form-Question__Prefilled"
              creatable
              name="question"
              onChange={handleOnSelectQuestion}
              options={getQuestionsOptions({ fetching, storyQuestions })}
              placeholder="Add your prompt..."
              required
              disabled={!!selectedPrompt}
            >
              <Icon icon="quote" />
            </SelectField>
          </Tooltip>
        </>
      ) : (
        <StoryQuestion
          disabled={!!story.question}
          fetching={fetching}
          onSelectQuestion={handleOnSelectQuestion}
          story={story}
          storyQuestions={storyQuestions}
        />
      )}
    </>
  );
};

export default PromptSelector;
